module.exports = __webpack_public_path__ + "img/sx_03.4682fb01.jpg";